// Module
var code = `<div class="header-content">
  <div class="branding">
    <div class="site-title">
      <h1>
        <a
          href="/"
          aria-label="Home"
          class="logo-link"
          data-channel="ROUTE"
          data-end-route="true"
          data-page-id="home"
          data-event-prevent-default="true"
        >
          <span></span>
        </a>
      </h1>
    </div>
    <!-- Insert Nav -->
  </div>
</div>
`;
// Exports
module.exports = code;